export default "__VITE_ASSET__CMMrWwuB__"